export default {"src":"/_next/static/media/document_bold.62ea0525.svg","height":24,"width":24};